import React from 'react';
import {createRoot} from 'react-dom/client';
import ProductComponent from './product/product';
import * as Sentry from '@sentry/react';
import {logger, setErrorReporter} from './logger';
import {installAntiforgeryRetry} from './global/antiforgery';
import {isProductPageRedesign} from './product/redesign/arm';

declare var __domain_name: string;
declare var __is_production: string;

Sentry.init({
    dsn: 'https://b2db459d7dc0ea78a26c57e6e1ee5647@o367868.ingest.us.sentry.io/4508019535380480',
    // The bundles carry the production DSN on every host: pages served by a local DF4 never report (staging still does).
    enabled: !/^(localhost|127\.0\.0\.1|df4\.microgsd\.net)$/.test(location.hostname),
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: __is_production === '1' ? 0.025 : 1,
    tracePropagationTargets: ['localhost', __domain_name],
    ignoreErrors: ['Non-Error exception captured', 'Non-Error promise rejection captured', 'InitializationError'],
    denyUrls: [/s\.pinimg\.com/, /connect\.facebook\.net/, /googletagmanager\.com/, /google-analytics\.com/, /bat\.bing\.com/, /klaviyo\.com/],
    environment: __is_production === '1' ? 'production' : 'development',
});
// Product page redesign #3 (q4_2026_product_page_3): B's errors carry the layout, so they can be told apart from the control's.
if (isProductPageRedesign()) {
    Sentry.setTag('product_layout', 'b');
}
setErrorReporter(r => (r.kind === 'exception' ? Sentry.captureException(r.error, {extra: r.extra, fingerprint: r.fingerprint, tags: r.tags}) : Sentry.captureMessage(r.message, {level: 'error', extra: r.extra, fingerprint: r.fingerprint})));
// A stale antiforgery token: refresh it and retry the request once (global/antiforgery.ts).
installAntiforgeryRetry();

const myErrorHandler = (error: Error, componentStack: string) => {
    logger.log('ERROR', error.message);
};

document.addEventListener('DOMContentLoaded', function () {
    const container: HTMLElement = document.getElementById('prod-v8') as HTMLElement;
    if (container) {
        const root = createRoot(container);
        root.render(
            <Sentry.ErrorBoundary
                fallback={
                    <div
                        role="alert"
                        aria-live="assertive"
                        className="text-center p-3"
                    >
                        Failed to load.
                    </div>
                }
            >
                <ProductComponent />
            </Sentry.ErrorBoundary>,
        );
    }
});
